module.exports = __webpack_public_path__ + "static/media/TestGlb.0ae8a47a.glb";